import { Component, Input } from '@angular/core';

import { Height } from '../../skeleton/placeholder-skeleton.types';
import { Size } from './placeholder-button.types';

/**
 * The height values for the button are arbitrary, only the small size was based on
 * designs in Figma. Same goes for the border radius values too.
 */
@Component({
  selector: `mg-placeholder-button`,
  template: `
    <mg-placeholder-skeleton
      [height]="height"
      borderRadius="xlarge">
    </mg-placeholder-skeleton>
  `,
})

//
export class PlaceholderButtonComponent {
  @Input() size: Size = 'small';

  get height() {
    const heightLookup: Record<Size, Height> = {
      small: '30',
      medium: '40',
      large: '56',
    };
    return heightLookup[this.size];
  }
}
